import { render, staticRenderFns } from "./InputDadosBancarios.vue?vue&type=template&id=b54bcc6a"
import script from "./InputDadosBancarios.vue?vue&type=script&lang=js"
export * from "./InputDadosBancarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports